module.exports = __webpack_public_path__ + "img/43.721fd1df.png";